var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlashOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-298 -723) translate(298 723)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M34.784 23h-7.531c.036 0 1.693-9.225 1.801-9.73.072-.288.145-.612.145-.937 0-.72-.505-1.333-1.118-1.333-.396 0-.756.252-.973.649-.18.36-2.054 3.892-2.558 4.9-.649 1.226-1.261 2.451-1.91 3.676s-1.261 2.45-1.91 3.712c-.504 1.009-2.558 5.009-2.558 5.009-.325.613-.18 1.441.36 1.838.18.144.396.216.576.216h7.532c-.036 0-1.946 10.342-1.946 10.414-.108.721.288 1.406.865 1.55.072 0 .144.036.216.036.36 0 .685-.216.901-.577 0 0 3.207-6.306 3.568-6.99.36-.721.72-1.442 1.117-2.163.36-.72.72-1.441 1.08-2.126.325-.649.685-1.333 1.01-1.982.288-.576.576-1.153.9-1.73.217-.432 1.298-2.378 1.298-2.378.108-.216.144-.432.144-.649.072-.792-.396-1.405-1.009-1.405z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 51,
    x: 1,
    y: 1,
    stroke: "#FFF",
    strokeWidth: 2,
    rx: 8
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlashOn);
export default __webpack_public_path__ + "static/media/flash-on.86d84209.svg";
export { ForwardRef as ReactComponent };